import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ComponentReloadService {

  // Quote
  private reloadQuoteData = new Subject<void>();
  reloadQuotes$ = this.reloadQuoteData.asObservable();

  // leads
  private reloadLeadData = new Subject<void>();
  reloadLeads$ = this.reloadLeadData.asObservable();

  // Travel prefence
  private reloadTravelPrefData = new Subject<void>();
  reloadTravelPref$ = this.reloadTravelPrefData.asObservable();

  // clients
  private reloadClientData = new Subject<void>();
  reloadClients$ = this.reloadClientData.asObservable();

  // tasks
  private reloadTaskData = new Subject<void>();
  reloadTasks$ = this.reloadTaskData.asObservable();

  // inventory itinerary
  private reloadInventoryItineraryData = new Subject<void>();
  reloadInventoryItinerary$ = this.reloadInventoryItineraryData.asObservable();

  // Contacts
  private reloadContactData = new Subject<void>();
  reloadContacts$ = this.reloadContactData.asObservable();

  // Vouchers
  private reloadVoucherData = new Subject<void>();
  reloadVouchers$ = this.reloadVoucherData.asObservable();

  // Invoices
  private reloadInvoiceData = new Subject<void>();
  reloadInvoices$ = this.reloadInvoiceData.asObservable();

  // Payment
  private reloadPaymentData = new Subject<void>();
  reloadPayment$ = this.reloadPaymentData.asObservable();

  // Meetings
  private reloadMeetingData = new Subject<void>();
  reloadMeetings$ = this.reloadMeetingData.asObservable();

  // vendors
  private reloadVendorContactsData = new Subject<void>();
  reloadVendorsContacts$ = this.reloadVendorContactsData.asObservable();

  // agents
  private reloadAgentContactsData = new Subject<void>();
  reloadAgentContacts$ = this.reloadAgentContactsData.asObservable();

  // DMCs
  private reloadDMCContactsData = new Subject<void>();
  reloadDMCContactsS$ = this.reloadDMCContactsData.asObservable();

  // Inventory template
  private reloadInventoryTemplateData = new Subject<void>();
  reloadInventoryTemplate$ = this.reloadInventoryTemplateData.asObservable();
  
  // Inventory hotels
  private reloadInventoryHotelsData = new Subject<void>();
  reloadInventoryHotels$ = this.reloadInventoryHotelsData.asObservable();

  // organizations
  private reloadOrg = new Subject<void>();
  reloadOrgs$ = this.reloadOrg.asObservable();

  // users 
  private reloadUsers = new Subject<void>();
  reloadUsers$ = this.reloadUsers.asObservable();

  // Visa Inventory
  private reloadVisaInventory = new Subject<void>();
  reloadVisaInventory$ = this.reloadVisaInventory.asObservable();

  // Visa lead
  private reloadVisaLead = new Subject<void>();
  reloadVisaLead$ = this.reloadVisaLead.asObservable();

  // DMC packages
  private reloadDMCPackages = new Subject<void>();
  reloadDMCPackages$ = this.reloadDMCPackages.asObservable();

   // dmcemials
   private reloadVendorDmcsInLeadDetails = new Subject<void>();
   reloadVendorDmcsInLeadDetails$ = this.reloadVendorDmcsInLeadDetails.asObservable();

   private reloadVendorDmcsInPopup = new Subject<void>();
   reloadVendorDmcsInPopup$ = this.reloadVendorDmcsInPopup.asObservable();

   private reloadVehiclesList = new Subject<void>();
   reloadVehiclesList$ = this.reloadVehiclesList.asObservable();

   private reloadVehiclesOverview = new Subject<void>();
   reloadVehiclesOverview$ = this.reloadVehiclesOverview.asObservable();
  constructor() { }

  ///////////////////////////
  // Trigger realod actions
  ///////////////////////////

  // quotes
  triggerQuotesReload() {
    this.reloadQuoteData.next();
  }
  
  // leads
  triggerLeadsReload() {
    this.reloadLeadData.next();
  }

  // Organizations
  triggerOrganizationReload(){
    this.reloadOrg.next();
  }

  // users 
  triggerUsersReload(){
    this.reloadUsers.next();
  }
  // Travel prefence
  triggerTravelPrefReload() {
    this.reloadTravelPrefData.next();
  }

  // clients
  triggerClientsReload() {
    this.reloadClientData.next();
  }

  // tasks
  triggerTasksReload() {
    this.reloadTaskData.next();
  }

  // inventory itinerary
  triggerInventoryItineraryReload() {
    this.reloadInventoryItineraryData.next();
  }

  // Invenotry Hotels
  triggerInvenotryHotelsReload(){
    this.reloadInventoryHotelsData.next();
  }

  // Contacts
  triggerContactsReload() {
    this.reloadContactData.next();
  }

  // vouchers
  triggerVouchersReload() {
    this.reloadVoucherData.next();
  }
  
  // Invoices
  triggerInvoicesReload() {
    this.reloadInvoiceData.next();
  }

  // Payment
  triggerPaymentReload() {
    this.reloadPaymentData.next();
  }

  // Meetings
  triggerMeetingsReload() {
    this.reloadMeetingData.next();
  }

  // vendors
  triggerVendorContactsReload() {
    this.reloadVendorContactsData.next();
  }

  // Agent
  triggerAgentContactsReload() {
    this.reloadAgentContactsData.next();
  }
  
  // DMCs
  triggerDMCContactsReload() {
    this.reloadDMCContactsData.next();
  }

  // Inventory template
  triggerInventoryTemplateReload() {
    this.reloadInventoryTemplateData.next();
  }

  // Visa inventory
  triggerVisaInventoryReload() {
    this.reloadVisaInventory.next();
  }

  // Visa lead
  triggerVisaLeadReload() {
    this.reloadVisaLead.next();
  }

  // DMC packages
  triggerDMCPackagesReload() {
    this.reloadDMCPackages.next();
  }

  triggerreloadVendorDmcsInLeadDetails() {
    this.reloadVendorDmcsInLeadDetails.next();
  }

  triggerreloadVendorDmcsInPopup() {
    this.reloadVendorDmcsInPopup.next();
  }

  triggerreloadvehicleslist() {
    this.reloadVehiclesList.next();
  }

  triggerreloadvehicleoverview() {
    this.reloadVehiclesOverview.next();
  }

}
